module.exports = __webpack_public_path__ + "img/tb.0b6c0625.png";